import styled from 'styled-components';

const ContentText = styled.div`
  white-space: pre-wrap;
  margin: 1em 0;
  font-size: 16px;
`;

export default ContentText;
